import React from "react";
import { ReactComponent as Folder } from "assets/img/svg/Folder2.svg";

const NoBranchOverlay = ({ editMode }) => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center">
      <Folder className="my-2" style={{ width: "72px", height: "72px" }} />
      <span className="text-sm text-light">
        {editMode ? "Please add a branch here" : "No branches added"}
      </span>
    </div>
  );
};

export default NoBranchOverlay;
